import { useState } from 'react';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material';

// components
import { TableCircularProgress } from 'src/components/table';
import CasTableCell from './_internal/CasTableCell';
import ICasTableColumn from './ICasTableColumn';
import CasTableError from './CasTableError';
import CasTableNoData from './CasTableNoData';

export type TRowSx = (row: any) => SxProps<Theme>;

interface ICasTableBody {
  loading: boolean;
  columns: ICasTableColumn[];
  rowData: any[];
  error: null | string;
  rowSx?: TRowSx;
  rowChildrenColumns?: ICasTableColumn[];
}

export default function CasTableBody({
  loading = false,
  columns,
  rowData,
  error,
  rowSx,
  rowChildrenColumns,
}: ICasTableBody) {
  const [expandedRows, setExpandedRows] = useState<Record<number, boolean>>({});

  return (
    <TableBody>
      {loading ? (
        <TableCircularProgress loading={loading} />
      ) : (
        rowData?.map((row, index) => (
          <>
            <TableRow key={index} sx={{ ...(rowSx ? rowSx(row) : {}) }} hover>
              {columns?.map((column, colIndex) => (
                <CasTableCell
                  key={`${index}${colIndex}`}
                  row={row}
                  column={column}
                  onToggleExpand={() =>
                    setExpandedRows((prev) => ({ ...prev, [index]: !prev[index] }))
                  }
                  isExpanded={expandedRows[index]}
                />
              ))}
            </TableRow>
            {expandedRows[index] &&
              row?.subMenus?.map((childRow: any, childIndex: number) => (
                <TableRow key={`child-${index}-${childIndex}`}>
                  {rowChildrenColumns?.map((childColumn: ICasTableColumn, colIndex: number) => (
                    <CasTableCell
                      key={`child-cell-${index}-${childIndex}-${colIndex}`}
                      row={childRow}
                      column={childColumn}
                    />
                  ))}
                </TableRow>
              ))}
          </>
        ))
      )}
      {!rowData?.length && !loading && !error && <CasTableNoData notFound />}
      {error && <CasTableError message={error} />}
    </TableBody>
  );
}
